import NotificationPart from 'localization/base/pages/rdevNotifications/NotificationPart';

const notificationType: NotificationPart = {
  internetOutage: 'Internetausfall',
  osVersionChanged: 'Änderung der Betriebssystemversion',
  rdevVersionChanged: 'RDev Versionsänderung'
};

export default notificationType;
